<template>
  <div class="create-category">
    <el-row type="flex" align="middle" class="page-title">
      <i class="el-icon-menu mr-s" />
      <h3>Thêm danh mục bài viết</h3>
    </el-row>
    <el-row>
      <el-col :span="24" :lg="16">
        <el-card>
          <el-form :model="form" ref="form" :rules="rules">
            <el-form-item label="Tên danh mục" prop="name">
              <el-input
                v-model="form.name"
                :disabled="callingAPI"
                @input="handleGenerateSlug"
                placeholder="Tên danh mục"
              />
            </el-form-item>
            <el-form-item label="Slug danh mục" prop="slug">
              <el-input v-model="form.slug" readonly placeholder="" />
            </el-form-item>
            <el-form-item label="Mô tả">
              <el-input
                type="textarea"
                :rows="3"
                v-model="form.description"
                :disabled="callingAPI"
                placeholder="Mô tả"
              />
            </el-form-item>
            <el-form-item label="SEO title">
              <el-input
                v-model="form.metaTitle"
                :disabled="callingAPI"
                placeholder="SEO title"
              />
            </el-form-item>
            <el-form-item label="SEO keyword">
              <el-input
                v-model="form.metaKeyword"
                :disabled="callingAPI"
                placeholder="SEO keyword"
              />
            </el-form-item>
            <el-form-item label="SEO description">
              <el-input
                v-model="form.metaDescription"
                :disabled="callingAPI"
                placeholder="SEO description"
              />
            </el-form-item>
          </el-form>
          <el-row type="flex" justify="end" class="mt-xl">
            <el-button
              class="mt-xl"
              type="primary"
              :loading="callingAPI"
              @click="handleCreateCategory"
            >
              Thêm danh mục
            </el-button>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  createCategory,
  fetchCategoryById,
  updateCategory,
} from "@/services/category";

const slugify = require("slugify");
export default {
  name: "CreateUpdateCategory",
  data() {
    return {
      callingAPI: false,

      form: {
        name: "",
        slug: "",
        description: "",
        metaTitle: "",
        metaKeyword: "",
        metaDescription: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "Tên danh mục không được để trống",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  beforeMount() {
    if (this.$route.params.id) {
      this.loadData();
    }
  },
  methods: {
    async loadData() {
      try {
        this.loadingData = true;
        const response = await fetchCategoryById(this.$route.params.id);
        this.form = {
          ...this.form,
          name: response.data.name,
          slug: response.data.slug,
          description: response.data.description,
          metaTitle: response.data.meta_title,
          metaKeyword: response.data.meta_keyword,
          metaDescription: response.data.meta_description,
        };
        this.loadingData = false;
      } catch (error) {
        this.loadingData = false;
      }
    },

    handleGenerateSlug() {
      this.form.slug = slugify(this.form.name);
    },

    async handleCreateCategory() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            this.callingAPI = true;
            const data = {
              name: this.form.name,
              description: this.form.description,
              slug: this.form.slug,
              meta_title: this.form.metaTitle,
              meta_keyword: this.form.metaKeyword,
              meta_description: this.form.metaDescription,
            };
            let response = null;
            if (this.$route.params.id) {
              response = await updateCategory(this.$route.params.id, data);
            } else {
              response = await createCategory(data);
            }
            this.callingAPI = false;
            this.$router.push({ name: "ManageCategory" });
            if (response.status == 1) {
              const message = this.$route.params.id
                ? "Cập nhật danh mục thành công."
                : "Thêm danh mục thành công.";
              this.$notify.success({
                title: "Thành công",
                message: message,
                duration: 2000,
              });
            } else {
              this.$notify.error({
                title: "Thất bại",
                message: response.errors[0],
                duration: 2000,
              });
            }
          } catch (error) {
            const message = this.$route.params.id
              ? "Cập nhật danh mục thất bại."
              : "Thêm danh mục thất bại.";
            this.$notify.error({
              title: "Thất bại",
              message: message,
              duration: 2000,
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.search-posts {
  width: 300px;
}
</style>
